import { ProductVideo } from 'components/ProductVideo';
import * as React from 'react';
export default {
  ProductVideo,
  React
};